export const restApiFields = {
  basic: [
    {
      field: "restUsername",
      label: "Username",
      type: "text",
      placeholder: "Enter username",
    },
    {
      field: "restPassword",
      label: "Password",
      type: "password",
      placeholder: "Enter password",
    },
  ],
  bearerToken: [
    {
      field: "bearerToken",
      label: "Bearer Token",
      type: "text",
      placeholder: "Enter Bearer Token",
    },
  ],
};

export const payloadContentTypeFields = {
  json: [
    {
      field: "payload",
      label: "Payload",
      type: "editor",
    }
  ],
  formData: [
    {
      field: "formData",
      label: "Form Data",
      type: "keyValue",
    },
    {
      field: "addFormData",
      type: "button",
      label: "Add Form Data",
    }
  ],
};
